import { forwardRef } from 'react';
import ReactSelect, { components } from 'react-select';
import styled from 'styled-components';

const Input = (props) => {
  return <components.Input {...props} autoComplete="none" />;
};

const DropdownIcon = styled.div`
  display: inline-block;
  width: 0.825em;
  height: 0.85em;
  transform: translateY(-56%) rotate(45deg);
  box-shadow: 2.8px 2.8px var(--chakra-colors-feature-secondary);
`;

const DropdownIndicator = () => <DropdownIcon />;

const StyledReactSelect = styled(ReactSelect)`
  font-size: 14px;
  cursor: pointer;
  width: 100%;

  .react-select__control {
    display: block;
    border-radius: 2px;
    border-color: #dedede !important;
    transition: border-color 0.2s ease;
  }

  .react-select__control--is-disabled {
    background-color: #f4f4f4;
  }

  .react-select__control--is-focused {
    box-shadow: none;
    border-color: var(--chakra-colors-separator-border) !important;
  }

  :not(.react-select--is-disabled) {
    .react-select__control {
      background: white;
      cursor: pointer;
    }

    :hover {
      .react-select__control {
        border-color: var(--chakra-colors-interaction-main) !important;
      }
    }
  }

  .react-select__indicators {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0.8em;
    padding-right: 0;

    .react-select__indicator {
      padding: 0 8px;
    }
  }

  .react-select__indicator-separator {
    background-color: inherit;
  }

  .react-select__placeholder {
    color: var(--chakra-colors-feature-placeholder);
    line-height: 3.2em;
    padding-right: 1.8em;
  }

  .react-select__multi-value__label {
    font-size: inherit;
  }

  .react-select__multi-value__remove:hover {
    background-color: #2684ff;
    color: white;
  }

  input[id^='react-select-'] {
    opacity: 1 !important;
  }
`;

const Select = forwardRef(
  (
    {
      className,
      disabled,
      onChange,
      options,
      value,
      defaultValue,
      components,
      styles,
      id,
      menuPortalTarget = document.body,
      ...props
    },
    ref,
  ) => {
    const findOption = (value) =>
      value == null
        ? value
        : Array.isArray(value)
        ? options.filter((option) => value.includes(option.value))
        : options.find((option) => option.value === value);

    return (
      <StyledReactSelect
        ref={ref}
        inputId={id}
        className={className}
        classNamePrefix="react-select"
        components={{ Input, DropdownIndicator, ...components }}
        isDisabled={disabled}
        onChange={(option, actionType) => {
          if (Array.isArray(option)) {
            return onChange(option.map((op) => op.value));
          } else {
            onChange((option || {}).value, actionType);
          }
        }}
        options={options}
        value={findOption(value)}
        defaultValue={findOption(defaultValue)}
        menuPortalTarget={menuPortalTarget}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          ...styles,
        }}
        {...props}
      />
    );
  },
);

Select.displayName = 'Select2';

/**
 * @deprecated use Select from '@frontend/components' instead.
 */
const StyledSelect = styled(Select)``;

export default StyledSelect;
